/**
 * TW PDP — logs a console message whenever a variant is selected
 * on the "Product information" section (main-product.liquid), and
 * syncs the FAQ's per-scent answer by the clicked scent box's
 * position (index), not by matching its name/key.
 */
(function () {
  'use strict';

  function logVariantChange(event) {
    var detail = event.detail || {};
    var sectionId = detail.sectionId;
    var variantId = detail.variantId;

    var variant = null;
    if (window.TwVariantSelector && typeof window.TwVariantSelector.getVariantFromProductData === 'function') {
      var productJson = document.querySelector('[id^="TwPdpProductJSON-"]');
      if (productJson) {
        var productId = productJson.id.replace('TwPdpProductJSON-', '');
        variant = window.TwVariantSelector.getVariantFromProductData(productId, variantId);
      }
    }

    console.log('[TwVariantClickLogger] variant changed', {
      sectionId: sectionId,
      variantId: variantId,
      variant: variant
    });
  }

  function syncFaqByIndex(index) {
    document.querySelectorAll('[data-tw-faq-scent-answers][data-scent-array]').forEach(function (container) {
      var arr;
      try {
        arr = JSON.parse(container.getAttribute('data-scent-array'));
      } catch (e) {
        return;
      }
      if (!Array.isArray(arr) || arr[index] == null) return;
      container.innerHTML = arr[index];
    });
  }

  function onScentBoxClick(event) {
    var box = event.target.closest('.tw-scent-box');
    if (!box) return;
    var container = box.closest('[id^="tw-scent-boxes-"]');
    if (!container) return;

    var boxes = Array.from(container.querySelectorAll('.tw-scent-box'));
    var index = boxes.indexOf(box);
    console.log('[TwVariantClickLogger] scent box clicked, index=', index);
    if (index < 0) return;

    syncFaqByIndex(index);
  }

  document.addEventListener('tw:pdp-variant-changed', logVariantChange);
  document.addEventListener('click', onScentBoxClick);
})();
